import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ApolloResponse1aeginapbuksm as ApolloResponse } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { withContextp2qc4rbktyej as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ProducerScopeb3mmhvfa6ll7 as ProducerScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { Builder3moivcm5iuump as Builder_1 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import {
  flowOn2q2f1gsn1yu9y as flowOn,
  buffer2o7vhreze5nfc as buffer,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor28nn2rq891clj as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_channelFlow) {
        this.n63_1 = $this_channelFlow;
      }
      *o63(it, $completion) {
        yield* this.n63_1.d1b(it, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o63(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0($this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda$slambda())($this_channelFlow);
  var l = (it, $completion) => i.o63(it, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing, $this_channelFlow) {
        this.p63_1 = this$0;
        this.q63_1 = $apolloRequest;
        this.r63_1 = $throwing;
        this.s63_1 = $this_channelFlow;
      }
      *c1g($this$withContext, $completion) {
        var tmp = this.p63_1.t63(this.q63_1, this.r63_1);
        var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda_0(this.s63_1);
        yield* tmp.a1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambda$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambda$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda_0(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda$slambda())(this$0, $apolloRequest, $throwing, $this_channelFlow);
  var l = ($this$withContext, $completion) => i.c1g($this$withContext, $completion);
  l.$arity = 1;
  return l;
}
var BuilderClass;
function Builder_2() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.u63_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.v63_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.w63_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.x63_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.y63_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.z63_1 = ArrayList().p2();
        this.a64_1 = this.z63_1;
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_4.b64_1 = ArrayList().p2();
        this.c64_1 = this.b64_1;
        this.d64_1 = Companion_getInstance().g43_1;
        this.e64_1 = null;
        this.f64_1 = null;
        this.g64_1 = null;
        this.h64_1 = null;
        this.i64_1 = null;
        this.j64_1 = null;
        this.k64_1 = null;
        this.l64_1 = null;
        this.m64_1 = null;
        this.n64_1 = null;
        this.o64_1 = null;
        this.p64_1 = null;
        this.q64_1 = null;
        this.r64_1 = null;
        this.s64_1 = null;
        this.t64_1 = null;
        this.u64_1 = null;
        this.v64_1 = null;
        this.w64_1 = null;
        this.x64_1 = null;
        this.y64_1 = null;
        this.z64_1 = null;
        this.a65_1 = null;
        this.b65_1 = true;
      }
      c65() {
        return this.u63_1.d38();
      }
      d65() {
        return plus(plus(plus(this.v63_1, this.w63_1), this.x63_1), this.y63_1);
      }
      t43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.b65_1 = sendEnhancedClientAwareness;
        return this;
      }
      s43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.y64_1 = failFastIfOffline;
        return this;
      }
      e65(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.w64_1 = retryOnError;
        return this;
      }
      f65(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.x64_1 = retryOnErrorInterceptor;
        return this;
      }
      g65(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.z64_1 = cacheInterceptor;
        return this;
      }
      h65(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.a65_1 = autoPersistedQueryInterceptor;
        return this;
      }
      k43(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.e64_1 = httpMethod;
        return this;
      }
      l43(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.f64_1 = httpHeaders;
        return this;
      }
      n43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.g64_1 = sendApqExtensions;
        return this;
      }
      o43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.h64_1 = sendDocument;
        return this;
      }
      p43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.i64_1 = enableAutoPersistedQueries;
        return this;
      }
      q43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.j64_1 = canBeBatched;
        return this;
      }
      i65(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.n64_1 = serverUrl;
        return this;
      }
      j65(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.n64_1 = httpServerUrl;
        return this;
      }
      k65(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.o64_1 = httpEngine;
        return this;
      }
      l65(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.s64_1 = httpExposeErrorBody;
        return this;
      }
      m65(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.z63_1.a5();
        this.z63_1.u2(httpInterceptors);
        return this;
      }
      n65(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.p64_1 = webSocketServerUrl;
        return this;
      }
      o65(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.v64_1 = webSocketServerUrl;
        return this;
      }
      p65(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.q64_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      q65(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.r64_1 = wsProtocolFactory;
        return this;
      }
      r65(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.t64_1 = webSocketEngine;
        return this;
      }
      s65(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.u64_1 = webSocketReopenWhen;
        return this;
      }
      t65(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.k64_1 = networkTransport;
        return this;
      }
      u65(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.l64_1 = subscriptionNetworkTransport;
        return this;
      }
      v65(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.u63_1.a5();
        this.u63_1.w46(customScalarAdapters);
        return this;
      }
      w65(listeners) {
        // Inline function 'kotlin.apply' call
        this.b64_1.a5();
        this.b64_1.u2(listeners);
        return this;
      }
      x65(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.m64_1 = dispatcher;
        return this;
      }
      i43(executionContext) {
        // Inline function 'kotlin.apply' call
        this.d64_1 = executionContext;
        return this;
      }
      d38() {
        return new (ApolloClient())(this.y38());
      }
      y38() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_2())()).v65(this.u63_1.d38());
        this_0.v63_1.u2(this.v63_1);
        this_0.w63_1.u2(this.w63_1);
        this_0.x63_1.u2(this.x63_1);
        this_0.y63_1.u2(this.y63_1);
        return this_0.x65(this.m64_1).i43(this.d64_1).k43(this.e64_1).l43(this.f64_1).j65(this.n64_1).k65(this.o64_1).l65(this.s64_1).m65(this.a64_1).n43(this.g64_1).o43(this.h64_1).p43(this.i64_1).q43(this.j64_1).t65(this.k64_1).u65(this.l64_1).n65(this.p64_1).o65(this.v64_1).r65(this.t64_1).s65(this.u64_1).p65(this.q64_1).q65(this.r64_1).e65(this.w64_1).f65(this.x64_1).g65(this.z64_1).h65(this.a65_1).s43(this.y64_1).w65(this.c64_1).t43(this.b65_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_2);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.y65_1 = function_0;
      }
      *s1d(value, $completion) {
        return yield* this.y65_1(value, $completion);
      }
      i5() {
        return this.y65_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var ApolloClient$executeAsFlowInternal$slambdaClass;
function ApolloClient$executeAsFlowInternal$slambda() {
  if (ApolloClient$executeAsFlowInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $apolloRequest, $throwing) {
        this.z65_1 = this$0;
        this.a66_1 = $apolloRequest;
        this.b66_1 = $throwing;
      }
      *c66($this$channelFlow, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.z65_1.b63_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.d66(this.a66_1);
        }
        try {
          yield* withContext(this.z65_1.r62_1.e66_1, ApolloClient$executeAsFlowInternal$slambda$slambda_0(this.z65_1, this.a66_1, this.b66_1, $this$channelFlow), $completion);
        }finally {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = this.z65_1.b63_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            element_0.g66(this.a66_1);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.c66((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$executeAsFlowInternal$slambdaClass = $;
  }
  return ApolloClient$executeAsFlowInternal$slambdaClass;
}
function ApolloClient$executeAsFlowInternal$slambda_0(this$0, $apolloRequest, $throwing) {
  var i = new (ApolloClient$executeAsFlowInternal$slambda())(this$0, $apolloRequest, $throwing);
  var l = ($this$channelFlow, $completion) => i.c66($this$channelFlow, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClient$apolloResponses$slambdaClass;
function ApolloClient$apolloResponses$slambda() {
  if (ApolloClient$apolloResponses$slambdaClass === VOID) {
    class $ {
      *o63(response, $completion) {
        if (!(response.e45_1 == null)) {
          throw ensureNotNull(response.e45_1);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o63(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ApolloClient$apolloResponses$slambdaClass = $;
  }
  return ApolloClient$apolloResponses$slambdaClass;
}
function ApolloClient$apolloResponses$slambda_0() {
  var i = new (ApolloClient$apolloResponses$slambda())();
  var l = (response, $completion) => i.o63(response, $completion);
  l.$arity = 1;
  return l;
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.q62_1 = builder;
        this.u62_1 = this.q62_1.d65();
        this.v62_1 = this.q62_1.c65();
        this.w62_1 = this.q62_1.z64_1;
        this.x62_1 = this.q62_1.a65_1;
        this.y62_1 = this.q62_1.w64_1;
        this.z62_1 = this.q62_1.x64_1;
        this.a63_1 = this.q62_1.y64_1;
        this.b63_1 = this.q62_1.c64_1;
        this.c63_1 = this.q62_1.b65_1;
        this.d63_1 = this.q62_1.d64_1;
        this.e63_1 = this.q62_1.e64_1;
        this.f63_1 = this.q62_1.f64_1;
        this.g63_1 = this.q62_1.g64_1;
        this.h63_1 = this.q62_1.h64_1;
        this.i63_1 = this.q62_1.i64_1;
        this.j63_1 = this.q62_1.j64_1;
        var tmp = this;
        var tmp_0;
        if (!(this.q62_1.k64_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.n64_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.o64_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.q62_1.a64_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.s64_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.q62_1.k64_1);
        } else {
          // Inline function 'kotlin.check' call
          if (!!(this.q62_1.n64_1 == null)) {
            var message_3 = "Apollo: 'serverUrl' is required";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).i65(ensureNotNull(this.q62_1.n64_1));
          if (!(this.q62_1.o64_1 == null)) {
            this_0.n66(ensureNotNull(this.q62_1.o64_1));
          }
          if (!(this.q62_1.s64_1 == null)) {
            this_0.o66(ensureNotNull(this.q62_1.s64_1));
          }
          tmp_0 = this_0.p66(this.q62_1.a64_1).d38();
        }
        tmp.s62_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.q62_1.l64_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.p64_1 == null)) {
            var message_4 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.t64_1 == null)) {
            var message_5 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.q64_1 == null)) {
            var message_6 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.r64_1 == null)) {
            var message_7 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.u64_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          // Inline function 'kotlin.check' call
          if (!(this.q62_1.v64_1 == null)) {
            var message_9 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_9));
          }
          tmp_2 = ensureNotNull(this.q62_1.l64_1);
        } else {
          var tmp0_elvis_lhs = this.q62_1.p64_1;
          var url = tmp0_elvis_lhs == null ? this.q62_1.n64_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.s62_1;
          } else {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_1())()).i65(url);
            if (!(this.q62_1.t64_1 == null)) {
              this_1.w66(ensureNotNull(this.q62_1.t64_1));
            }
            if (!(this.q62_1.q64_1 == null)) {
              this_1.x66(ensureNotNull(this.q62_1.q64_1));
            }
            if (!(this.q62_1.r64_1 == null)) {
              this_1.y66(ensureNotNull(this.q62_1.r64_1));
            }
            if (!(this.q62_1.u64_1 == null)) {
              this_1.z66(this.q62_1.u64_1);
            }
            if (!(this.q62_1.v64_1 == null)) {
              this_1.a67(this.q62_1.v64_1);
            }
            tmp_3 = this_1.d38();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.t62_1 = tmp_2;
        var tmp1_elvis_lhs = this.q62_1.m64_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.r62_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope_0(dispatcher));
        this.k63_1 = new (NetworkInterceptor())(this.s62_1, this.t62_1);
      }
      b67(query) {
        return ApolloCall().o62(this, query);
      }
      c67(mutation) {
        return ApolloCall().o62(this, mutation);
      }
      l6() {
        cancel(this.r62_1.f66_1);
        this.s62_1.uz();
        this.t62_1.uz();
      }
      l63(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda_0(this, apolloRequest, throwing));
        return buffer(flowOn(flow, Dispatchers_getInstance().j13_1), 2147483647);
      }
      t63(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.h44();
        this_0.i43(this.r62_1.u44(this.v62_1).u44(apolloClient.d63_1).u44(this_0.v42_1));
        var tmp0_elvis_lhs = this_0.w42_1;
        this_0.k43(tmp0_elvis_lhs == null ? apolloClient.e63_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.z42_1;
        this_0.n43(tmp1_elvis_lhs == null ? apolloClient.g63_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.a43_1;
        this_0.o43(tmp2_elvis_lhs == null ? apolloClient.h63_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.y42_1;
        this_0.p43(tmp3_elvis_lhs == null ? apolloClient.i63_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.c43_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.f63_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.x42_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.l43(headers);
        var tmp4_elvis_lhs = this_0.b43_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.j63_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.m43('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.d43_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.y62_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.r43(tmp);
        var tmp7_elvis_lhs = this_0.e43_1;
        this_0.s43(tmp7_elvis_lhs == null ? apolloClient.a63_1 : tmp7_elvis_lhs);
        this_0.t43(apolloClient.c63_1);
        var request = this_0.d38();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.q62_1.v63_1);
        if (!(this.w62_1 == null)) {
          this_2.i2(this.w62_1);
        }
        this_2.u2(this.q62_1.w63_1);
        if (!(this.x62_1 == null)) {
          this_2.i2(this.x62_1);
        }
        this_2.u2(this.q62_1.x63_1);
        var tmp0_elvis_lhs_2 = this.z62_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.q62_1.y63_1);
        this_2.i2(this.k63_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).f67(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda_0());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_2 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
